export default __webpack_public_path__ + "static/media/house-17.918919d6.jpg";